import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { RegionModel } from 'src/models';

const regionAdapter: AdapterFunc<GQL.RegionModel, RegionModel> = (input) => ({
  id: input.id,
  name: input.name!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
});

export default regionAdapter;
